module.exports = __webpack_public_path__ + "media/images/proof_links/colored/reddit-1f3ef16d16dcc962ee3369615e5416c6.svg";